module.exports = __webpack_public_path__ + "img/cancel.2f5e15ec.png";